import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchStatusesApi } from '../../api/statuses-api';
import { setQuickLinks } from 'reducers/quick-links-slice';
import { formatOptionsForSelect } from 'utils/filters-util';

const initialState = {
  activeColumns: [],
  statuses: [],
  types: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchStatusesListing = createAsyncThunk(
  'statuses/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
    try {
      const paramsObj = {
        sort: 'position asc',
        ...updatedParamsObject,
      };
      const res = await fetchStatusesApi(paramsObj);
      if (res?.status) {
        dispatch(setQuickLinks(res?.user_filters));
      }
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

const StatusesSlice = createSlice({
  name: 'statuses',
  initialState,
  reducers: {
    setStatusesLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setStatusesActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
    setStatusEdit: (state, { payload }) => {
      state.statuses = state.statuses?.map((status) => (status?.id === payload?.id ? payload : status));
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchStatusesListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchStatusesListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.statuses = action?.payload?.data || [];
        state.types = formatOptionsForSelect({
          list: (action?.payload?.status_types || []).map((type) => type?.slug),
        });
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchStatusesListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setStatusesActiveColumn, setStatusesLoading, setStatusEdit } = StatusesSlice.actions;
export default StatusesSlice.reducer;
